// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class HomeGuidanceCatalog {
    static HomeOverviewModule: IGuidanceTopic = {
        name: "Home_Overview",
        modulePath: PLATFORM.moduleName("guidance/Home/Overview.html"),
        title: "Help",
        moduleType: WorkflowModuleType.Help,
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Overview of the help sections",
        hidden: true,
    };
}
